import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SectionPartners.module.css';

import IconLuganoregionLogo from './logos/IconLuganoregionLogo';
import IconGiorgioRoccaLogo from './logos/IconGiorgioRoccaLogo';
import IconCarvLogo from './logos/IconCarvLogo';
import IconNiedeckerLogo from './logos/IconNiedeckerLogo';
import IconFlowLogo from './logos/IconFlowLogo';
import IconYoyotennisLogo from './logos/IconYoyotennisLogo';
import IconTokoLogo from './logos/IconTokoLogo';
import IconTicinoLogo from './logos/IconTicinoLogo';
import IconBellinzonaLogo from './logos/IconBellinzonaLogo';
import IconAsconaLogo from './logos/IconAsconaLogo';
import IconHellyHansenLogo from './logos/IconHellyHansenLogo';
import IconZagSkisLogo from './logos/IconZagSkisLogo';
import IconMilanoCortinaLogo from './logos/IconMilanoCortinaLogo';
import IconElanSkisLogo from './logos/IconElanSkisLogo';
import IconWEMountainLogo from './logos/IconWEMountainLogo';
import GenovaLogo from './logos/logo-genova.png';
import AmsiLogo from './logos/logo-amsi.png';

const ALL_PARTNERS = [
  {
    key: 'visitgenoa.it',
    url: 'https://www.visitgenoa.it/',
    logo: props => <img {...props} src={GenovaLogo} alt="Visit Genoa" />,
    logoClassName: classNames(css.imageAsLogo, css.height80),
  },
  {
    key: 'amsi.it',
    url: 'https://amsi.it/',
    logo: props => <img {...props} src={AmsiLogo} alt="Associazione Maestri di Sci Italiani" />,
    logoClassName: classNames(css.imageAsLogo, css.height80),
  },
  {
    key: 'hellyhansen.com',
    url: 'https://www.hellyhansen.com/',
    logo: IconHellyHansenLogo,
    logoClassName: css.height70,
  },
  {
    key: 'elanskis.com',
    url: 'https://elanskis.com/',
    logo: IconElanSkisLogo,
    logoClassName: css.carv,
  },
  {
    key: 'milanocortina2026.olympics.com',
    url: 'https://milanocortina2026.olympics.com/',
    logo: IconMilanoCortinaLogo,
    logoClassName: css.height80,
  },
  {
    key: 'ticino.ch',
    url: 'https://www.ticino.ch/',
    logo: IconTicinoLogo,
    logoClassName: css.carv,
  },
  {
    key: 'bellinzonaevalli.ch',
    url: 'https://www.bellinzonaevalli.ch/',
    logo: IconBellinzonaLogo,
    logoClassName: css.height80,
  },
  {
    key: 'ascona-locarno.com',
    url: 'https://www.ascona-locarno.com/',
    logo: IconAsconaLogo,
    logoClassName: css.height70,
  },
  { key: 'luganoregion.com', url: 'https://www.luganoregion.com/en', logo: IconLuganoregionLogo },
  { key: 'w3mountain.com', url: 'https://w3mountain.com', logo: IconWEMountainLogo },
  { key: 'giorgiorocca.com', url: 'https://www.giorgiorocca.com/en/', logo: IconGiorgioRoccaLogo },
  {
    key: 'nidecker.com',
    url: 'https://www.nidecker.com/en/',
    logo: IconNiedeckerLogo,
    logoClassName: css.nidecker,
  },
  {
    key: 'zagskis.com',
    url: 'https://www.zagskis.com/',
    logo: IconZagSkisLogo,
    logoClassName: classNames(css.height70, css.fillBlack),
  },
  { key: 'toko.ch', url: 'https://www.toko.ch/en/', logo: IconTokoLogo },
  {
    key: 'getcarv.com',
    url: 'https://getcarv.com/',
    logo: IconCarvLogo,
    logoClassName: css.carv,
  },
  {
    key: 'flow-bindings.com',
    url: 'https://www.flow-bindings.com/en/',
    logo: IconFlowLogo,
    logoClassName: css.flow,
  },
  { key: 'yoyo-tennis.ch', url: 'https://www.yoyo-tennis.ch/', logo: IconYoyotennisLogo },
];

const SectionPartners = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.content}>
        <span className={css.eyebrow}>
          <FormattedMessage id="SectionPartners.eyebrow" defaultMessage="Trusted partners & sponsors" />
        </span>
        <h2 className={css.title}>
          <FormattedMessage id="SectionPartners.ourPartnersTitle" />
        </h2>

        <div className={css.marqueeOuter}>
          <div className={css.marqueeTrack}>
            {[...ALL_PARTNERS, ...ALL_PARTNERS].map((partner, i) => {
              const Logo = partner.logo;
              return (
                <a
                  key={`${partner.key}-${i}`}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.partnerItem}
                  aria-label={partner.key}
                >
                  <Logo className={classNames(css.partnerLogo, partner.logoClassName)} />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

SectionPartners.defaultProps = {
  rootClassName: null,
  className: null,
};

SectionPartners.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionPartners;
